import { render, staticRenderFns } from "./materiel-delete-index.vue?vue&type=template&id=e0880966"
import script from "./materiel-delete-index.vue?vue&type=script&lang=js"
export * from "./materiel-delete-index.vue?vue&type=script&lang=js"
import style0 from "./materiel-delete-index.vue?vue&type=style&index=0&id=e0880966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports